interface LogoProps {
  className?: string;
}

const Logo = ({ className = "w-10 h-10" }: LogoProps) => {
  return (
    <svg
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      shapeRendering="geometricPrecision"
    >
      {/* Heart Trail - Sunset Coral - hand-drawn, sketchy, open at bottom */}
      {/* Curves up for left lobe, descends to bottom point, curves up for right lobe, open trailing end */}
      <path
        d="M10 26
           Q9 16 12 17
           Q15 18 18 19
           Q21 20 24 19
           Q27 18 30 17
           Q33 16 32 26
           Q31 30 28 29
           Q25 28 22 28.5
           Q19 29 16 28.5
           Q13 28 10 26"
        stroke="#FF6F61"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Paper Plane - Deep Slate - oriented right and slightly upwards, with visible fold */}
      {/* Main body - pointing right and slightly up */}
      <path d="M5 27 L16 13 L19 15 L8 30 Z" fill="#2F3640" />
      {/* Right wing fold - visible fold for 3D quality */}
      <path d="M16 13 L19 15 L14 17 Z" fill="#2F3640" opacity="0.85" />
    </svg>
  );
};

export default Logo;

